import AddImage from "@/components/field-components/AddImage"
import ImagePreview from "@/components/layout-components/ImagePreview"
import { Box, Button, CircularProgress, TextField } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { NotesContext } from "../NotesModuleContext"
import { useForm } from "react-hook-form"
import styles from "./AddNotes.module.css"
import { TImageModal } from "../../../../interface/ImagePreview"
import AsyncImage from "@/components/common/AsyncImage"
import { extractImageTimeStamp, extractImageUrl, responseToImagePreview } from "@/utils/CommonFunctions"

const AddNotes = () => {
  const { addNotes } = useContext(NotesContext)

  const { notesCount, mutation, onSubmit } = addNotes as any
  const { handleSubmit, register, reset, setValue } = useForm()

  const [parentSelectedFiles, setParentSelectedFiles] = useState<any[]>([])
  const [prevImage, setPrevImage] = useState<TImageModal>({ isOpen: false, images: [], startIndex: 0 })

  useEffect(() => {
    setValue("addNote.images", parentSelectedFiles)
  }, [parentSelectedFiles])

  useEffect(() => {
    reset()
    setParentSelectedFiles([])
  }, [notesCount])

  const handleFilesSelected = (selectedFiles: any[]) => {
    setParentSelectedFiles(selectedFiles)
  }

  const deleteFile = (index: number) => {
    const updatedSelectedFiles = [...parentSelectedFiles]
    updatedSelectedFiles.splice(index, 1)
    setParentSelectedFiles(updatedSelectedFiles)
  }

  const handleOpenImagePreview = (images: Array<any>, index: number) => {
    const imageList = images.map(responseToImagePreview)
    setPrevImage({
      isOpen: true,
      images: imageList,
      startIndex: index,
    })
  }

  const handleCloseImagePreview = () => {
    setPrevImage({
      isOpen: false,
      images: [],
      startIndex: 0,
    })
  }

  return (
    <Box className={styles.AddNotesSection}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box className={styles.Header}>
          <Box className={styles.Title}>Add Notes</Box>
        </Box>

        <Box className={styles.Editor}>
          <TextField
            id="outlined-multiline-static"
            label="Note Details"
            multiline
            rows={4}
            fullWidth
            sx={{
              "& .MuiOutlinedInput-input": {
                color: "rgba(255, 255, 255, 0.7)",
              },
              "& fieldset, & .Mui-focused fieldset": {
                borderColor: "#3CA63C",
                borderRadius: "6px",
                borderWidth: "1px",
              },
              "&:hover fieldset, &:hover .Mui-focused fieldset": {
                borderColor: "#3CA63C",
                borderWidth: "1px",
              },
              "& .MuiInputBase-root.Mui-focused fieldset": {
                "&:hover fieldset": {
                  borderColor: "#3CA63C",
                },
                borderColor: "#3CA63C",
              },
              "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline ": {
                borderColor: "#3CA63C",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "rgba(255, 255, 255, 0.7)",
              },
            }}
            {...register("addNote.notes", {
              required: true,
            })}
          />
        </Box>

        <Box className={styles.ActionContainer}>
          <AddImage onFilesSelected={handleFilesSelected} parentSelectedFilesLength={parentSelectedFiles.length} />
          <Button
            startIcon={mutation?.isLoading && <CircularProgress size={16} sx={{ color: "white" }} />} //
            className={styles.SaveDetails}
            disabled={mutation?.isLoading}
            type="submit"
          >
            Save Notes
          </Button>
        </Box>
        <Box className={styles.AttachmentTitle}>Attachments (Maximum uploads upto 5 photos)</Box>
        <Box
          sx={{
            marginRight: "2rem",
            display: "flex",
            gap: "2%",
            mt: "1.5rem",
          }}
        >
          {parentSelectedFiles.length > 0 &&
            parentSelectedFiles.map((item, index) => {
              return (
                <Box key={`image_${index}`} sx={{ position: "relative", marginRight: "1rem" }}>
                  <AsyncImage
                    alt={`Attachment${index}`}
                    src={extractImageUrl(item)}
                    width={70}
                    height={70}
                    onClick={() => handleOpenImagePreview(parentSelectedFiles, index)}
                    title={extractImageTimeStamp(item)}
                    style={{ borderRadius: "0.5rem", marginBottom: "4px" }}
                  />
                  <CloseIcon
                    onClick={() => deleteFile(index)}
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      cursor: "pointer",
                      borderRadius: "50%",
                      padding: "3px",
                      color: "black",
                      backgroundColor: "white",
                    }}
                    fontSize="small"
                  />
                </Box>
              )
            })}
          <ImagePreview startIndex={prevImage.startIndex} images={prevImage.images} isOpen={prevImage.isOpen} onClose={handleCloseImagePreview} />
        </Box>
      </form>
    </Box>
  )
}

export default AddNotes
